<template>
  <ul class="grid grid-cols-2 md:grid-cols-3">
    <li v-for="option in options">
      <button
        class="grid grid-cols-[1fr_auto] items-center w-full px-2 py-1 rounded-md gap-2"
        :class="{
          'canhover:hover:bg-neutral-300 canhover:hover:dark:bg-neutral-700 text-neutral-700 dark:text-neutral-300':
            !included.includes(option.value) &&
            !excluded.includes(option.value),
          'canhover:hover:bg-green-500/30 text-green-500': included.includes(
            option.value,
          ),
          'canhover:hover:bg-red-500/30 text-red-500': excluded.includes(
            option.value,
          ),
        }"
        @click="toggleOption(option)"
      >
        <div>
          <p
            class="text-left"
            :class="[
              (included.includes(option.value) ||
                excluded.includes(option.value)) &&
                'font-semibold',
            ]"
          >
            {{ option.text }}
          </p>
          <p
            v-if="option.description"
            class="text-left text-xs font-light text-neutral-600 dark:text-neutral-400"
          >
            {{ option.description }}
          </p>
        </div>
        <IconCheck v-if="included.includes(option.value)" />
        <IconX v-else-if="excluded.includes(option.value)" />
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts" generic="T">
import { IconCheck, IconX } from "@tabler/icons-vue";

export type Option<T> = {
  text: string;
  value: T;
  description?: string;
  loading?: boolean;
};

export type Props<T> = {
  included: T[];
  excluded: T[];
  includedMode: "and" | "or";
  excludedMode: "and" | "or";
  options: Option<T>[];
};

const props = defineProps<Props<T>>();

const emit = defineEmits<{
  (e: "update:included", v: T[]): void;
  (e: "update:excluded", v: T[]): void;
  (e: "update:includedMode", v: "and" | "or"): void;
  (e: "update:excludedMode", v: "and" | "or"): void;
}>();

function toggleOption(option: Option<T>) {
  const foundIndexOnIncluded = props.included.indexOf(option.value);
  const foundIndexOnExcluded = props.excluded.indexOf(option.value);

  if (foundIndexOnIncluded !== -1) {
    emit(
      "update:included",
      props.included.filter((_, i) => i !== foundIndexOnIncluded),
    );
    emit("update:excluded", [...props.excluded, option.value]);
  } else if (foundIndexOnExcluded !== -1) {
    emit(
      "update:excluded",
      props.excluded.filter((_, i) => i !== foundIndexOnExcluded),
    );
  } else {
    emit("update:included", [...props.included, option.value]);
  }
}
</script>
